const handlers = {
  handleClick: ({ setAnchor }) => event => {
    setAnchor(event.currentTarget)
  },

  handleClose: props => () => {
    props.setAnchor(null)
  }
}

export default handlers
